// Styles have been copied to packages/editor/generative-ai-modal/examples/utils/components/Modals.tsx
// Updates to this file should also be copied to there.
import { css } from '@emotion/react';
import { N0, N20A, N40A, N60A } from '@atlaskit/theme/colors';
export const FLOATING_AI_BUTTON_SIZE = 24;
export const FLOATING_AI_ICON_SIZE = 14;
export const floatingAIButtonWrapperStyles = css`
  position: absolute;
  top: var(--position-top);
  left: var(--position-left);
  height: var(--content-height);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const floatingAIButtonStyles = css`
  cursor: pointer;
  border: 1px solid ${`var(--ds-surface, ${N0})`};
  box-shadow: ${`var(--ds-shadow-raised, ${`0 1px 1px ${N60A}`})`};
  border-radius: 50%;
  width: ${FLOATING_AI_BUTTON_SIZE}px;
  height: ${FLOATING_AI_BUTTON_SIZE}px;
  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    background-color: ${`var(--ds-background-neutral-subtle-hovered, ${N20A})`};
  }

  :active {
    background-color: ${`var(--ds-background-neutral-subtle-pressed, ${N40A})`};
  }

  transition: background 200ms ease 0s, border 200ms ease 0s;
  padding: ${"var(--ds-space-050, 4px)"};

  background-color: ${`var(--ds-surface-overlay, ${N0})`};

  // disable pointer events to avoid default tooltip since we are adding custom one
  > svg {
    pointer-events: none;
  }
`;